import { defineStore } from 'pinia'
import {
  fetchFinanceSummaryApi,
  FINANCE_MOBILE_PAGE_SIZE,
} from '@/entities/finance/api/financeApi'

export const useFinanceStore = defineStore('finance', {
  state: () => ({
    role: null,
    balance: 0,
    currency: 'VND',
    balanceAvailable: true,
    accruals: [],
    accrualsTotal: 0,
    listSkip: 0,
    listLimit: FINANCE_MOBILE_PAGE_SIZE,
    isLoading: false,
    error: null,
    hasLoaded: false,
    listRequestId: 0,
  }),
  getters: {
    listPageIndex: (state) =>
      state.listLimit > 0 ? Math.floor(state.listSkip / state.listLimit) : 0,
    listPageCount: (state) =>
      state.listLimit > 0 ? Math.max(1, Math.ceil(state.accrualsTotal / state.listLimit)) : 1,
  },
  actions: {
    clear() {
      this.role = null
      this.balance = 0
      this.currency = 'VND'
      this.balanceAvailable = true
      this.accruals = []
      this.accrualsTotal = 0
      this.listSkip = 0
      this.listLimit = FINANCE_MOBILE_PAGE_SIZE
      this.isLoading = false
      this.error = null
      this.hasLoaded = false
      this.listRequestId = 0
    },

    setListPage(pageIndex) {
      if (!this.role) {
        return
      }
      const nextSkip = Math.max(0, Number(pageIndex) || 0) * this.listLimit
      if (nextSkip === this.listSkip) {
        return
      }
      this.listSkip = nextSkip
      return this.fetchSummary(this.role)
    },

    setListLimit(limit) {
      const nextLimit = Math.max(1, Number(limit) || FINANCE_MOBILE_PAGE_SIZE)
      if (nextLimit !== this.listLimit) {
        this.listLimit = nextLimit
        this.listSkip = 0
      }
      if (!this.role) {
        return
      }
      return this.fetchSummary(this.role)
    },

    async fetchSummary(role) {
      if (!role) {
        return
      }

      if (this.role !== role) {
        this.role = role
        this.listSkip = 0
        this.accruals = []
        this.accrualsTotal = 0
        this.balance = 0
        this.balanceAvailable = true
        this.hasLoaded = false
      }

      const requestId = ++this.listRequestId
      const skip = this.listSkip
      const limit = this.listLimit

      this.isLoading = true
      this.error = null

      try {
        const summary = await fetchFinanceSummaryApi(role, { skip, limit })
        if (requestId !== this.listRequestId) {
          return
        }
        this.balance = summary.balance
        this.currency = summary.currency
        this.balanceAvailable = summary.balanceAvailable
        this.accruals = summary.accruals
        this.accrualsTotal = summary.total
        this.hasLoaded = true
      } catch (error) {
        if (requestId !== this.listRequestId) {
          return
        }
        this.error = error
        this.accruals = []
        this.accrualsTotal = 0
      } finally {
        if (requestId === this.listRequestId) {
          this.isLoading = false
        }
      }
    },
  },
})
